//@ts-nocheck

import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

const loadingText = () => {
  const wrapper = document.querySelector(".js-loading-wrapper");
  if (!wrapper) {
    return;
  }

  const text = Array.from(wrapper.querySelectorAll(".js-loading-item"));
  const height = wrapper.getBoundingClientRect().height;
  let t1 = gsap.timeline({
    scrollTrigger: {
      trigger: wrapper,
      start: "top center",
      end: "+=" + height,
      scrub: true,
    },
  });
  text.forEach((item, index) => {
    t1.to(
      item,
      {
        color: "#100904",
        ease: "steps(1)",
      },
      index
    );
    if (text[index - 1]) {
      t1.to(
        text[index - 1],
        {
          color: "#c4c4c4",
          ease: "steps(1)",
        },
        index
      );
    }
  });
};

export default loadingText;
